import loglevel from "loglevel";

const logger = loglevel.getLogger("productionLogger");
logger.setDefaultLevel(loglevel.levels.WARN);

export const productionLogger = logger;
